import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="legacy-footer">
      {/* Gamble Responsibly Yellow Bar */}
      <div className="gamble-responsibly-bar">
        <span>
          Don't chase your losses. Walk away. <strong>Gamble Responsibly</strong>. Need help? Call Gambling Help on <strong>1800 858 858</strong>
        </span>
      </div>

      {/* Footer Links Section */}
      <div className="footer-links-section">
        <div className="footer-container">
          <div className="footer-columns">
            <div className="footer-column">
              <h4>Home</h4>
              {['Bet', 'Travel', 'Membership', 'Affiliates', 'FAQ', 'Support'].map(t => (
                <a key={t} href="/">{t}</a>
              ))}
            </div>
            <div className="footer-column">
              <h4>About</h4>
              {['How It Works', 'Our Story', 'Press', 'Contact', 'Jobs'].map(t => (
                <a key={t} href="/">{t}</a>
              ))}
            </div>
            <div className="footer-column">
              <h4>Terms & Conditions</h4>
              {['Terms Of Use', 'Privacy Policy', 'Disclaimer', 'Know Your Customer', 'Credit Card Security'].map(t => (
                <a key={t} href="/">{t}</a>
              ))}
            </div>
            <div className="footer-column">
              <h4>Punt Club for Business</h4>
              {['Punters clubs for Pubs', 'Punters clubs for Sporting Clubs', 'Punters clubs for Racing Clubs', 'Punters clubs for Offices', 'Punters clubs for Shipping'].map(t => (
                <a key={t} href="/">{t}</a>
              ))}
            </div>
          </div>

          {/* Social Icons */}
          <div className="footer-social">
            <a href="https://facebook.com/puntclub" target="_blank" rel="noopener noreferrer" className="social-icon">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://instagram.com/puntclub" target="_blank" rel="noopener noreferrer" className="social-icon">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://open.spotify.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <i className="fab fa-spotify"></i>
            </a>
          </div>

          {/* Copyright */}
          <div className="footer-copyright">
            &copy; {new Date().getFullYear()} (c) V.0
          </div>
        </div>
      </div>
    </footer>
  );
}
